export default __webpack_public_path__ + "a5dcf4b9bdf7d09e9c0208fc81f598c8.png";